import React, { useState } from 'react';
import { Form, Input, Button, Typography, Alert, Card } from 'antd';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../context/AuthContext";

const { Title, Text } = Typography;

const Login = () => {
  const [mensaje, setMensaje] = useState('');
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const onFinish = async (values) => {
    setMensaje('');
    setError(false);

    try {
      const res = await axios.post('https://app-swingervip-production.up.railway.app/api/login-admin', {
        email: values.email,
        password: values.password,
      });
      login(res.data.token, res.data.user);
      setMensaje('Inicio de sesión exitoso');
      setError(false);

      navigate('/admin');
    } catch (err) {
      console.error('Error al iniciar sesión:', err);
      setMensaje(err.response?.data?.message || 'Error al iniciar sesión');
      setError(true);
    }
  };

  return (
    <div className="admin-login-shell">
      <Card
        className="admin-login-card"
        style={{ borderRadius: 12 }}
        bodyStyle={{ padding: 24 }}
      >
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
          <img
            src={require('../assets/image/logo.png')} // Cambia esto por la ruta correcta o una URL válida
            alt="Logo"
            style={{ width: 100, height: 'auto' }}
          />
        </div>

        <Title level={3} style={{ textAlign: 'center', marginBottom: 8 }}>
          Bienvenido
        </Title>
        <Text type="secondary" style={{ display: 'block', textAlign: 'center', marginBottom: 24 }}>
          Inicia sesión en tu cuenta
        </Text>

        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            label="Correo electrónico"
            name="email"
            rules={[
              { required: true, message: 'Por favor ingresa tu correo electrónico' },
              { type: 'email', message: 'El correo no es válido' },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Contraseña"
            name="password"
            rules={[{ required: true, message: 'Por favor ingresa tu contraseña' }]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              style={{
                background: 'linear-gradient(135deg, #363683 0%, #d62874 100%)',
                fontWeight: 'bold',
                height: 40,
              }}
            >
              Iniciar Sesión
            </Button>
          </Form.Item>
        </Form>

        {mensaje && (
          <Alert
            message={mensaje}
            type={error ? 'error' : 'success'}
            showIcon
            style={{ marginTop: 16 }}
          />
        )}
      </Card>
    </div>
  );
};

export default Login;
